// src/components/ResultsCalculator.jsx
import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

// 🔹 Vérité officielle Jeu 1
const THE_TRUTH = {
    a1: "c3",
    a2: "c4",
    a3: "c6",
    a4: "c1",
    a5: "c2",
    a6: "c5",
};

// 🔹 Gagnant réel Jeu 2
const REAL_WINNER = "c3";

const characters = [
    { id: "c1", name: "La Comptesse de Wurtenberg" },
    { id: "c2", name: "Hystérix la Gauloise" },
    { id: "c3", name: "Angela Secret" },
    { id: "c4", name: "Emo King" },
    { id: "c5", name: "Hairspray Becca" },
    { id: "c6", name: "Jungle Beast" },
];

const ResultsCalculator = () => {
    const [jeu1Results, setJeu1Results] = useState([]);
    const [jeu2Results, setJeu2Results] = useState([]);

    useEffect(() => {
        fetchResults();
    }, []);

    const fetchResults = async () => {
        // ---------- JEU 1 ----------
        const submissionsSnap = await getDocs(collection(db, "submissions"));
        const jeu1 = [];

        submissionsSnap.forEach(doc => {
            const data = doc.data();
            let score = 0;

            data.submission?.forEach(g => {
                if (THE_TRUTH[g.actorId] === g.characterId) score++;
            });

            jeu1.push({
                user: `${data.first_name} ${data.last_name}`,
                score
            });
        });

        // TRI score décroissant
        jeu1.sort((a, b) => b.score - a.score);
        setJeu1Results(jeu1);

        // ---------- JEU 2 ----------
        const winnerSnap = await getDocs(collection(db, "winner_predictions"));
        const jeu2 = [];

        winnerSnap.forEach(doc => {
            const data = doc.data();
            jeu2.push({
                user: `${data.first_name} ${data.last_name}`,
                vote: data.winner,
                correct: data.winner === REAL_WINNER
            });
        });

        setJeu2Results(jeu2);
    };

    return (
        <div style={{ padding: 20, maxWidth: 900, margin: "0 auto", color: "black", fontFamily: "Arial" }}>
            <h2>🏆 Résultats</h2>

            {/* ---------- JEU 1 ---------- */}
            <h3>Jeu 1 – Qui est qui</h3>

            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 40 }}>
                <thead>
                    <tr style={{ background: "#eee" }}>
                        <th style={th}>Rang</th>
                        <th style={th}>Score</th>
                        <th style={th}>Participant</th>
                    </tr>
                </thead>
                <tbody>
                    {jeu1Results.map((r, i) => (
                        <tr key={i} style={{ background: i === 0 ? "#ffd966" : "white" }}>
                            <td style={td}>{i + 1}</td>
                            <td style={td}><b>{r.score}</b></td>
                            <td style={td}>{r.user}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* ---------- JEU 2 ---------- */}
            <h3>Jeu 2 – Qui va gagner ?</h3>

            {characters.map(c => {
                const votesForThis = jeu2Results.filter(r => r.vote === c.id);

                return (
                    <div
                        key={c.id}
                        style={{
                            marginBottom: 20,
                            background: "#fff",
                            padding: 10,
                            borderRadius: 8,
                            border: "1px solid #ccc"
                        }}
                    >
                        {/* Nom du personnage + symbole ✅/❌ */}
                        <h4 style={{ marginBottom: 8, color: "black" }}>
                            {c.name} {c.id === REAL_WINNER ? "✅" : "❌"}
                        </h4>

                        {votesForThis.length > 0 ? (
                            <ul style={{ paddingLeft: 20, color: "black" }}>
                                {votesForThis.map((r, idx) => (
                                    <li key={idx}>{r.user}</li>
                                ))}
                            </ul>
                        ) : (
                            <p style={{ fontStyle: "italic", color: "black" }}>
                                Aucun vote pour ce personnage
                            </p>
                        )}
                    </div>
                );
            })}

        </div>
    );
};

const th = {
    padding: 10,
    border: "1px solid #999",
    color: "black"
};

const td = {
    padding: 10,
    border: "1px solid #ccc",
    color: "black"
};

export default ResultsCalculator;
